// 每日小時成本
import * as types from '../actionType';

let initState = {
};

function Min30CostChart(state = initState, action) {
  switch (action.type) {
      case types.MIN30_COST_CHART_SUCCESS:{
        return action.result;
      }
      default:
        return state;
  }
}

export default Min30CostChart;
